import dayjs from "dayjs";

export const formatIso = (dayTime: string): string => dayjs(dayTime).format("MM-DD-YY h:mm:ss A");
